import React from 'react'
import useRouter from '../hooks/use-router'
import { Operation } from '@morningtrain/resources'
import { useEnvValue } from '@morningtrain/react-helpers'

export default function PushCurrentRouteToHistory () {
  const router = useRouter()

  const [currentUrl] = useEnvValue('router.currentUrl')

  React.useEffect(() => {
    if (!history || typeof (history.pushState) !== 'function') {
      return
    }

    const operation = Operation.fromRoute(router.currentRoute)

    const title = (operation) ? operation.getEnv('title') : null
    const urlWihtHash = location.hash ? currentUrl + location.hash : currentUrl

    if (location.href !== currentUrl) {
      history.pushState({ route: router.currentRoute, parameters: router.currentParameters }, title, urlWihtHash)
    } else {
      history.replaceState({ route: router.currentRoute, parameters: router.currentParameters }, title, urlWihtHash)
    }
  }, [currentUrl])

  return null
}
